import * as React from 'react';
import {
    Box,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
} from '@mui/material';
import { CertificationStandardEnum, CERTIFICATION_LABEL } from '../companyCertificates';
import { CompanyCertificates } from '../companyProfileApi';

type Props = {
    value: CompanyCertificates[];
    onChange: (certificates: CompanyCertificates[]) => void;
    companyProfileId: number;
};

export const CertificatesMultiSelect: React.FC<Props> = ({
    value,
    onChange,
    companyProfileId,
}) => {
    return (
        <FormGroup>
            {(Object.values(CertificationStandardEnum) as Array<string | number>)
                .filter((v): v is number => typeof v === 'number')
                .map((certIdNum) => {
                    const label = CERTIFICATION_LABEL[certIdNum as CertificationStandardEnum];

                    // zaznaczony, jeśli w value mamy wpis z tym certyfikatem
                    const selected = (value ?? []).some(c => {
                        // preferuj porównanie po numeric ID
                        if (typeof c.certificateId === 'number') return c.certificateId === certIdNum;
                        // fallback: gdyby przyszło stringiem w polu 'certificate'
                        const asNum = typeof c.certificate === 'string'
                            ? (CertificationStandardEnum as any)[c.certificate]
                            : c.certificate as number | undefined;
                        return asNum === certIdNum;
                    });

                    return (
                        <Box key={certIdNum} sx={{ mb: 1.5 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selected}
                                        onChange={(_, checked) => {
                                            const current = value ?? [];

                                            if (checked) {
                                                // dodaj, jeśli nie ma
                                                if (current.some(c => (c.certificateId ?? (CertificationStandardEnum as any)[c.certificate as any]) === certIdNum)) {
                                                    return;
                                                }
                                                const certEnum = certIdNum as CertificationStandardEnum;
                                                const newItem: CompanyCertificates = {
                                                    id: 0, // backend nada ID
                                                    companyProfileId: companyProfileId,
                                                    certificateId: certIdNum,
                                                    certificate: certEnum,
                                                };
                                                onChange([...current, newItem]);
                                            } else {
                                                // usuń
                                                const next = current.filter(c => {
                                                    const idByNumber = c.certificateId;
                                                    if (typeof idByNumber === 'number') return idByNumber !== certIdNum;
                                                    const asNum = typeof c.certificate === 'string'
                                                        ? (CertificationStandardEnum as any)[c.certificate]
                                                        : c.certificate as number | undefined;
                                                    return asNum !== certIdNum;
                                                });
                                                onChange(next);
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Box>
                                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                            {label}
                                        </Typography>
                                    </Box>
                                }
                            />
                        </Box>
                    );
                })}
        </FormGroup>
    );
};
